<div class="vtr-widget-questions"
	role="none"
	attr.aria-label="{{title}}-{{description}}">
	<div class="container-fluid">
		<div class="row">
			<div class="col">
				<div class="title {{'dirClass' | translate}}"
					id="{{linkId}}-title"
					attr.aria-label="{{linkId}}-title"
					role="text"
					dir="{{'dir' | translate}}">{{title}}</div>
				<div class="description {{'dirClass' | translate}}"
					id="{{linkId}}-description"
					attr.aria-label="{{linkId}}-description"
					role="text"
					dir="{{'dir' | translate}}">{{description}}</div>
			</div>
		</div>
		<div class="row filter">
			<div class="col chevron">
				<vtr-ui-list-chevron [items]="items"
					[iconPlacement]="'left'"
					metricsEvent="articleClick"
					[arrowColor]="'blue-arrow'"
					[clickable]="clickable"
					[chevronVisibility]="chevronVisibility"
					[blockPosition]="blockPosition"
					[linkId]="linkId"></vtr-ui-list-chevron>
			</div>
			<div class="cover"></div>
		</div>
	</div>
</div>
